import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { getCurrentSeason } from '@/lib/christianCalendar'

/**
 * Displays a seasonal upgrade banner when a Christian calendar season is active.
 * variant="pricing" — full banner for top of pricing page
 * variant="chat"    — compact inline banner for chat upgrade wall
 */
export default function SeasonalBanner({ variant = 'pricing' }) {
  const season = getCurrentSeason()
  const navigate = useNavigate()

  if (!season) return null

  if (variant === 'chat') {
    return (
      <div className="text-center px-2 py-1">
        <span className="text-xs text-[var(--gold)] font-medium">{season.chatBanner}</span>
      </div>
    )
  }

  // pricing variant — full banner
  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="max-w-5xl mx-auto mb-8 rounded-2xl bg-[var(--gold)]/10 border border-[var(--gold)]/30 px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-4"
    >
      <div className="flex items-center gap-3">
        <span className="text-2xl">{season.emoji}</span>
        <div>
          <span className="inline-block bg-[var(--gold)] text-[var(--text-on-gold)] text-xs font-bold px-3 py-0.5 rounded-full mb-1">
            {season.pricingBadge}
          </span>
          <p className="text-[var(--text-muted)] text-sm leading-relaxed max-w-lg">
            {season.pricingCopy}
          </p>
        </div>
      </div>
      <button
        onClick={() => navigate('/pricing')}
        className="shrink-0 bg-[var(--gold)] text-[var(--text-on-gold)] font-bold px-5 py-2.5 rounded-xl hover:opacity-90 transition-all text-sm whitespace-nowrap"
      >
        See Plans →
      </button>
    </motion.div>
  )
}
